export interface SapUserDTO {
    userEmail?: string;
    userFullName?: string;
    firstName?: string;
    lastName?: string;
    preferredLanguageCd?: string;
}
